import { LISTING_TRACK_EVENT_ORIGIN_TYPES } from '@/constants';
import { ListingPageEvent } from '@/constants/AnalyticEvents';
import routes from '@/constants/routes';
import { getAction, INIT_FAVOURITES } from '@/store/listings/actions';
import ExternalNavigationHelper from '@/utils/external-navigation';
import {
  AddToFavouritesAction,
  RemoveFromFavouritesAction,
  ShareAction,
  EditSecondaryAction,
} from '@/components/listing-card/helpers/actions';
import ListingGalleryActions from '../actions';

const ListingActionsMixin = {
  components: {
    ListingGalleryActions,
  },
  computed: {
    favourites() {
      return this.$store.state.listings.favourites;
    },
    listingActions() {
      const shareAction = new ShareAction({});
      const toggleFavouriteAction = this.favourites
        .some(({ listingId }) => listingId === this.listing.listingId)
        ? new RemoveFromFavouritesAction({
          analyticEvent: this.getTrackEventWithOrigin(ListingPageEvent.RemovedFromFavourites),
          store: this.$store,
        })
        : new AddToFavouritesAction({
          analyticEvent: this.getTrackEventWithOrigin(ListingPageEvent.AddedToFavourites),
          store: this.$store,
        });
      const editAction = new EditSecondaryAction({
        successHandler: (listing) => ExternalNavigationHelper.openInNewWindow(
          `/${routes.listingEditing}/${listing.listingId}`,
        ),
      });

      return [toggleFavouriteAction, shareAction].concat(this.editable ? [editAction] : []);
    },
  },
  async mounted() {
    await this.$store.dispatch(getAction(INIT_FAVOURITES));
  },
  methods: {
    getTrackEventWithOrigin(trackEvent) {
      const listingTrackEventOrigin = this.listing.isBode
        ? LISTING_TRACK_EVENT_ORIGIN_TYPES.Bode
        : LISTING_TRACK_EVENT_ORIGIN_TYPES.MLS;
      const isSoldProperty = process.client
        && window.location.pathname.includes(routes.soldProperty);

      return `${listingTrackEventOrigin}${isSoldProperty ? '_Sold Property' : ''}_${trackEvent}`;
    },
  },
};

export default ListingActionsMixin;
